import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";

export const ROLES_ALLOWED_TO_DEACTIVATE_USER: Array<AccessRoleCode> = [
  AccessRoleCodes.Customer,
  AccessRoleCodes.Merchant,
];
